import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2d1829d8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex flex-row space-x-2 items-center justify-start" };
const _hoisted_2 = { class: "text-md font-normal text-gray-900" };
const _hoisted_3 = ["src"];
const _hoisted_4 = {
    key: 0,
    class: "flex flex-wrap px-2",
    style: { "column-gap": "14px" }
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
    key: 1,
    class: "grid grid-cols-2 gap-1 px-1 py-1"
};
const _hoisted_8 = ["onClick"];
import { ChevronRightIcon } from '@gohighlevel/ghl-icons/24/outline';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIStickerCollapse',
    props: {
        title: {
            type: String,
            require: true,
        },
        options: {
            type: Array,
        },
        url: {
            type: String,
            require: true,
        },
        value: {
            type: String,
            require: true,
        },
    },
    emits: ['select-emoji', 'select-shape'],
    setup(__props, { emit: emits }) {
        /* eslint-disable @typescript-eslint/no-var-requires */
        const open = ref(false);
        function selectedEmoji(url) {
            emits('select-emoji', url);
        }
        function selectedShapes(option) {
            emits('select-shape', option);
        }
        function getImage(type) {
            const image = require(`@/assets/images/icon-${type}.svg`);
            return image.default;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["w-[232px] h-auto border rounded-lg flex flex-col space-y-2", open.value ? 'border-primary' : 'border-gray-300']),
                style: { "width": "240px" }
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(["w-full flex flex-row items-center justify-between py-2 px-2 h-20 cursor-pointer rounded-t-lg hl_collapse-bg", open.value ? 'bg-primary-50 border-b border-gray-300' : '']),
                    onClick: _cache[0] || (_cache[0] = ($event) => (open.value = !open.value))
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_unref(ChevronRightIcon), {
                            class: _normalizeClass(["w-5 h-5 text-gray-900 hl_collapse-icon", open.value ? 'hl_open-collapse' : ''])
                        }, null, 8, ["class"]),
                        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.title), 1)
                    ]),
                    _createElementVNode("img", {
                        src: getImage(__props.url),
                        class: "w-16 h-16 rounded-lg"
                    }, null, 8, _hoisted_3)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["flex flex-col hl_collapse-content overflow-hidden", open.value ? 'hl_collapse-maxheight' : ''])
                }, [
                    (__props.value === 'emojis')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: option,
                                    class: "flex flex-col items-center rounded-lg justify-center border border-gray-100 hover:border-primary-500 space-y-2 cursor-pointer w-16 h-16",
                                    onClick: ($event) => (selectedEmoji(option))
                                }, [
                                    _createElementVNode("img", {
                                        src: option,
                                        class: "w-14 h-14 rounded-lg"
                                    }, null, 8, _hoisted_6)
                                ], 8, _hoisted_5));
                            }), 128))
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: option,
                                    class: "flex flex-col items-center rounded-md justify-center border border-gray-100 hover:border-primary-500 space-y-2 cursor-pointer w-24 h-24",
                                    onClick: ($event) => (selectedShapes(option))
                                }, [
                                    _createElementVNode("span", {
                                        class: _normalizeClass(option.classes)
                                    }, null, 2)
                                ], 8, _hoisted_8));
                            }), 128))
                        ]))
                ], 2)
            ], 2));
        };
    }
});
